module.exports = __webpack_public_path__ + "img/wp-existing-habit-card1.cf878657.jpg";